/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconPyramids: {
  name: 'pyramids';
  data: string;
} = {
  name: 'pyramids',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M594.512 369.042 344.976 106.657 56.218 389.329l43.08 9.178-79.802 77.316 200.346 42.245 105.749-53.662-21.37-22.24 104.323 22.227 185.968-95.351zM218.304 511.979 30.648 473.54l152.278-146.906 16.79 87.961 1.055 5.531 17.533 91.853zm74.371-81.828-108.98-113.412-77.272 74.864-30.594-6.332L343.624 124.24l62.215 329.333-113.164-23.422z"/></svg>`,
};
